export enum PaginationDirection {
	Forward = 'Forward',
	Backward = 'Backward'
}
